import { Button, Select } from "@rio-cloud/rio-uikit";
import DateTimerFilter from "./DateTimerFilter";
import { useNavigate, useLocation } from "react-router";
import { useState } from "react";

interface Props {
    handleSearch: (text: string) => void;
    handleSubject: (subject: string) => void;
    handleDn: (text: string) => void;
    handleResponsible: (text: string) => void;
}

const ToollBar = ({ handleSearch, handleSubject, handleDn, handleResponsible }: Props) => {
    const [dn, setDn] = useState('');
    const [responsible, setResponsible] = useState('');
    const [text, setText] = useState('');
    const [subject, setSubject] = useState<string>('');
    const navigate = useNavigate();
    const location = useLocation();

    const handleChange = (value: string) => {
        setText(value);
        handleSearch(value)
    };

    const handleChangeSubject = (sub?: string) => {
        if (!sub) return;
        setSubject(sub);
        handleSubject(sub);
    }

    const handleChangeDn = (value: string) => {
        setDn(value);
        handleDn(value)
    };

    const handleChangeResponsible = (value: string) => {
        setResponsible(value);
        handleResponsible(value)
    };

    const goToNewSupportCall = () => {
        navigate({
            pathname: location.pathname + '/new-support-call',
        });
    };

    const SubjectOptions = [
    {
        id: 'TECHNICAL_SUPPORT',
        label: 'TAS - Suporte Técnico'
    }, {
        id: 'VOLKSTOTAL',
        label: 'Suporte Volkstotal'
    }, {
        id: 'all',
        label: 'Todos'
    }]

    return (
        <div className="margin-top-20">
            <div>
                <span className="text-medium text-size-18" style={{ color: "#2A3740" }}>Gestão de solicitacões</span>
            </div>

            <div className="table-toolbar">
                <div className="table-toolbar-container">
                    <div className="table-toolbar-group flex-1-1 align-items-end">
                        <div className="table-toolbar-column table-toolbar-column-spacer">
                            <Button onClick={goToNewSupportCall} bsStyle={Button.PRIMARY} iconName='rioglyph-plus' style={{ width: 150 }}>Nova solicitação</Button>
                        </div>

                        {/* <div className="table-toolbar-column table-toolbar-column-spacer flex-1-1">
                            <DateTimerFilter />
                        </div> */}

                        <div className="table-toolbar-column table-toolbar-column-spacer flex-1-1">
                            <input
                                type="text"
                                className="form-control"
                                placeholder='Busque por nº de solicitaçao, chassi, placa ou cliente'
                                id="chassisSearch"
                                value={text}
                                onChange={(event) => handleChange(event.target.value)}
                                maxLength={17}
                                style={{ height: "34px", minHeight: "34px", maxHeight: "34px", lineHeight: "34px" }}
                            />
                        </div>

                        <div className="table-toolbar-column table-toolbar-column-spacer" style={{ width: 200 }}>
                            <label htmlFor="assunto">Assunto</label>
                            <Select
                                id={`assunto`}
                                placeholder="Selecione"
                                value={[subject]}
                                options={SubjectOptions}
                                useFilter
                                className="border"
                                noItemMessage="Nenhum tipo de assunto encontrado"
                                onChange={(selected) => handleChangeSubject(selected?.id)}
                            />
                        </div>

                        <div className="table-toolbar-column table-toolbar-column-spacer" style={{ width: 200 }}>
                            <label htmlFor="responsible">Responsável</label>
                            {/* <Select
                                id={`responsible`}
                                placeholder="Selecione"
                                value={['']}
                                options={[]}
                                useFilter
                                className="border"
                                noItemMessage="Nenhum responsável encontrado"
                                onChange={(e) => { }}
                            /> */}
                            <input
                                type="text"
                                className="form-control"
                                id="responsible"
                                value={responsible}
                                onChange={(event) => handleChangeResponsible(event.target.value)}
                                maxLength={17}
                                style={{ height: "34px", minHeight: "34px", maxHeight: "34px", lineHeight: "34px" }}
                            />
                        </div>
                        <div className="table-toolbar-column" style={{ width: 200 }}>
                            <label htmlFor="dn">DN</label>
                            {/* <Select
                                id={`dn`}
                                placeholder="Selecione"
                                value={['']}
                                options={[]}
                                useFilter
                                className="border"
                                noItemMessage="Nenhum tipo de falha encontrado"
                                onChange={(e) => { }}
                            /> */}
                            <input
                                type="text"
                                className="form-control"
                                id="dn"
                                value={dn}
                                onChange={(event) => handleChangeDn(event.target.value)}
                                maxLength={17}
                                style={{ height: "34px", minHeight: "34px", maxHeight: "34px", lineHeight: "34px" }}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ToollBar;
